import React from 'react';
import { Badge, Text, Wrap, WrapItem } from '@chakra-ui/react';

// Mesmas cores/rótulos do painel de Vendas e da tela de Pendências.
const STATUS_VENDA_META = {
    confirmada: { label: 'CONFIRMADA', bg: 'gray.600', color: 'white' },
    enviar: { label: 'PARA ENVIAR', bg: 'yellow.200', color: 'black' },
    transito: { label: 'EM TRÂNSITO', bg: 'blue.500', color: 'white' },
    concluida: { label: 'CONCLUÍDA', bg: 'green.500', color: 'white' },
    cancelada: { label: 'CANCELADA', bg: 'red.500', color: 'white' },
};

const STATUS_TAGA_META = {
    1: { label: 'CONFIRMADA', bg: 'green.300', color: 'white' },
    2: { label: 'CANCELADA', bg: 'red.300', color: 'white' },
    3: { label: 'PENDENTE', bg: 'yellow.300', color: 'black' },
};

const rotuloCanal = (origem) =>
    String(origem || '').toUpperCase() === 'ECOMMERCE' ? 'SITE' : 'MERCADO LIVRE';

/** Status do canal de venda e status TAGA, sempre rotulados para não se confundirem. */
export const BadgesStatusVenda = ({ origem, status, statusTaga, size = 'xs' }) => {
    const canal = STATUS_VENDA_META[status];
    const taga = STATUS_TAGA_META[statusTaga];
    if (!canal && !taga) return null;

    return (
        <Wrap spacing={1}>
            {canal && (
                <WrapItem>
                    <Badge bg={canal.bg} color={canal.color} fontSize={size} px={2} py={0.5} borderRadius="full">
                        {rotuloCanal(origem)}: {canal.label}
                    </Badge>
                </WrapItem>
            )}
            {taga && (
                <WrapItem>
                    <Badge bg={taga.bg} color={taga.color} fontSize={size} px={2} py={0.5} borderRadius="full">
                        TAGA: {taga.label}
                    </Badge>
                </WrapItem>
            )}
        </Wrap>
    );
};

/** Data da venda e prazo de despacho, rotulados. */
export const DatasDespacho = ({ dataVenda, prazoEnvio, fontSize = '11px' }) => {
    if (!dataVenda && !prazoEnvio) return null;

    return (
        <Text fontSize={fontSize} color="gray.600">
            {dataVenda && (
                <>
                    <Text as="span" fontWeight="bold">Data da venda:</Text> {dataVenda}
                </>
            )}
            {dataVenda && prazoEnvio ? ' · ' : ''}
            {prazoEnvio && (
                <>
                    <Text as="span" fontWeight="bold">Prazo de despacho:</Text> {prazoEnvio}
                </>
            )}
        </Text>
    );
};
